import { Course } from '@yandex-int/k-common/typings';
import { Text, Link } from 'platform-components';
import { SelectEvent } from 'platform-components/src/typings';
import { withRouterPath, InjectedProps as WithRouterPathProps } from 'platform-components/hocs';
import React, { useEffect, useState } from 'react';

import CourseYearFilter from '../../course-year-filter/course-year-filter';

import './course-view__prev-year-pane.scss';

interface HOCProps extends WithRouterPathProps {}

interface OwnProps {
    children: React.ReactElement;
    courseId: number | null;
    courses: Array<Course>;
    onSelectCourse: (option: SelectEvent<number>) => void;
    shouldShow: boolean;
    /**
     * Начальное значение развёрнутости.
     * Нужно для того, чтобы показать сразу развёрнутый блок если кроме него на странице ничего нет
     * (когда предмет архивный и не доступен в этом году).
     */
    initialExpanded?: boolean | undefined;
}

interface Props extends HOCProps, OwnProps {}

/** Разворачивающийся блок с курсами прошлых лет */
const PrevYearPane = (props: Props) => {
    const {
        children,
        courseId,
        courses,
        match: {
            params: { classId, subject },
        },
        onSelectCourse,
        shouldShow,
        initialExpanded = false,
    } = props;

    const [isExpanded, setIsExpanded] = useState(initialExpanded);

    useEffect(() => {
        setIsExpanded(initialExpanded);
    }, [subject, classId]); // eslint-disable-line react-hooks/exhaustive-deps

    if (!shouldShow || !courseId) {
        return null;
    }

    return (
        <div className="course-view__prev-year-pane">
            <div className="course-view__prev-year-pane-controls">
                <Link
                    mix="course-view__prev-year-link"
                    onClick={() => setIsExpanded(!isExpanded)}
                    theme={Link.THEME.PRIMARY}
                >
                    <Text
                        id={isExpanded ? 'courseView.hidePrevYear' : 'courseView.showPrevYear'}
                        weight={Text.WEIGHT.M}
                    />
                </Link>
                {isExpanded && (
                    <CourseYearFilter courseId={courseId} courses={courses} onSelectCourse={onSelectCourse} />
                )}
            </div>
            {isExpanded && children}
        </div>
    );
};

const PrevYearPaneComponent = withRouterPath(PrevYearPane);

PrevYearPaneComponent.displayName = 'PrevYearPane';

export default PrevYearPaneComponent;
